import './wxLogin.scss';
import TBIcon from '../compoment/Icon';
import { Input, Button, message, Checkbox, Tooltip, Modal } from 'antd';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { tokenByWeChat, getUserLoginInfo } from '../utils/servers';
import { login, sendTextCode, checkLoginUserIsExist } from '../utils/servers';
import { useState, useRef } from 'react';
import { GetUrlParam } from '../utils';
import ReactSimpleVerify from 'react-simple-verify';
import 'react-simple-verify/dist/react-simple-verify.css';
import { debounce } from 'lodash';
import { connect } from 'react-redux';
import actions from '../utils/actions';
import Cookies from 'js-cookie';
import { CloseOutlined } from '@ant-design/icons';
import UserAgreement from '../compoment/userAgreement';
import { orgUsertree } from '../utils/dataProcessing';
function WxLogin(props) {
	const { saveLoginInfo, saveMenus, saveSySMenus, addUserOrgs, addUserInfo, addHeaderParentIds } =
		props;
	const history = useHistory();
	const [phone, setPhone] = useState('');
	const [code, setCode] = useState('');
	const [msgId, setMsgId] = useState('');
	const [codeTip, setCodeTip] = useState('获取');
	const [successTips, setSuccessTips] = useState('验证中..');
	const [successIcon] = useState('');
	const [disabledCode, setDisabledCode] = useState(true);
	const [showCodeBtn, setShowCodeBtn] = useState(false);
	const [matchedPhone, setMatchedPhone] = useState('');
	const couterRef = useRef();
	const orgTypeCode = GetUrlParam('loginCode');
	const bgImg = {
		1002015: 'fws',
		1002010: 'yg',
		1002020: 'syd',
		1002005: 'pt'
	};
	const TypeName = {
		1002015: '人力资源服务商',
		1002010: '用工企业',
		1002020: '运营商',
		1002005: '平台'
	};
	// 回车键登入
	document.onkeydown = keyListener;
	function keyListener(e) {
		// 当按下回车键，执行我们的代码
		if (code && e.keyCode === 13) {
			gotoLogin();
		}
	}
	const [weChatOpenId, setWeChatOpenId] = useState(undefined);
	const gotoLogin = () => {
		if (code && codeCheckbox) {
			if (phone !== matchedPhone) {
				message.error('手机号与验证码不匹配，请稍后重试');
			} else {
				login({ phone, code, msgId, orgTypeCode, weChatOpenId }).then((data) => {
					if (data.code === '200') {
						saveLoginInfo(data.data);
						Cookies.set('token', data.data.accessToken);
						localStorage.setItem('loginInfo', JSON.stringify(data.data));
						actions.setGlobalState({ loginInfo: data.data }); //通知主应用并修改initstate
						getUserLoginInfo().then((res) => {
							if (res.code === '200') {
								localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo) || {});
								actions.setGlobalState({ userInfo: res.data.userInfo });
								localStorage.setItem('menus', JSON.stringify(res.data.userRoleFuncList));
								saveMenus(res.data.userRoleFuncList ? res.data.userRoleFuncList : []);
								saveSySMenus(res.data.userRoleFuncList ? res.data.userRoleFuncList : []);
								addUserOrgs(orgUsertree(res.data.userOrgsInfoList) || []);
								addUserInfo(res.data.userInfo || {});
								addHeaderParentIds(res.data.userRoleFuncList[0]?.id);
								localStorage.setItem('myWorkplat', JSON.stringify(res.data.userWorkbenchList));
								// addMenusHistory(
								// 	res.data.userWorkbenchList.includes('1276005')
								// 		? [
								// 				{
								// 					path: '/zeus-system/system-permissions/workingPlatform',
								// 					name: '我的工作台',
								// 					parentId: '523523270839386118'
								// 				}
								// 		  ]
								// 		: []
								// );
								// window.location.reload();
							}
							history.push('/');
						});
					} else {
						message.error(data.msg || '账号异常，请稍后重试');
					}
				});
			}
		}
	};
	const changePhone = (event) => {
		setPhone(event.target.value);
	};
	const changeCode = (event) => {
		setCode(event.target.value);
	};
	const getCode = () => {
		if (!disabledCode) return;
		setDisabledCode(false);
		let i = 60;
		setCodeTip(`${i}S`);
		const T = setInterval(() => {
			i--;
			setCodeTip(`${i}S`);
			if (i <= 0) {
				clearInterval(T);
				setDisabledCode(true);
				setCodeTip(`获取`);
			}
		}, 1000);
		sendTextCode({ phone: phone }).then((data) => {
			if (data.code === '200') {
				setDisabledCode(false);
				setMsgId(data.data.msgId);
				setMatchedPhone(phone);
			} else {
				message.error(data.msg);
			}
		});
	};
	const checkPhone = () => {
		return checkLoginUserIsExist({
			phone,
			orgTypeCode
		});
	};
	const [showBindPage, setShowBindPage] = useState(false);
	const [codeCheckbox, setCodeCheckbox] = useState(true);
	const changeCodeCheckbox = () => {
		setCodeCheckbox(!codeCheckbox);
	};
	const success = debounce(() => {
		if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
			checkPhone().then((data) => {
				if (data.success) {
					setShowCodeBtn(true);
					setSuccessTips('验证成功');
				} else {
					couterRef.current.reset();
				}
			});
		} else {
			message.warn('请正确输入手机号！');
			couterRef.current.reset();
		}
	}, 500);

	//截取url中的参数
	function getUrlValue(kValue) {
		var url = window.location.href; //当前页面的地址
		var reg = /([^?&=]+)=([^?&=]+)/g;
		var obj = {};
		url.replace(reg, function () {
			obj[arguments[1]] = arguments[2];
		});
		for (var keyName in obj) {
			if (keyName === kValue) {
				return obj[keyName];
			}
		}
	}
	const backLoginPage = () => {
		history.push('/');
	};
	let [isModalOpen, setIsModalOpen] = useState(false);
	const openAgreement = () => {
		setIsModalOpen(true);
	};
	const [updateKey, setUpdateKey] = useState(1);
	const handleModalOk = () => {
		setIsModalOpen(false);
		setUpdateKey(new Date().getTime());
	};
	const handleModalCancel = () => {
		setIsModalOpen(false);
		setUpdateKey(new Date().getTime());
	};
	useEffect(() => {
		if (weChatOpenId === undefined) {
			Cookies.remove('token');
			localStorage.setItem('loginInfo', null);
			let requestData = {
				authCode: getUrlValue('code') // 授权码
				// orgId: null,
				// orgTypeCode: getUrlValue('loginCode') // 端code
			};
			if (getUrlValue('env')) {
				localStorage.setItem('env', getUrlValue('env'));
			} else {
				localStorage.setItem('env', '');
			}
			tokenByWeChat(requestData).then((data) => {
				if (data.code === '200') {
					if (data.data.weChatOpenId === undefined) {
						saveLoginInfo(data.data);
						Cookies.set('token', data.data.accessToken);
						localStorage.setItem('loginInfo', JSON.stringify(data.data));
						actions.setGlobalState({ loginInfo: data.data }); //通知主应用并修改initstate
						getUserLoginInfo().then((res) => {
							if (res.code === '200') {
								localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo) || {});
								actions.setGlobalState({ userInfo: res.data.userInfo });
								localStorage.setItem('menus', JSON.stringify(data.data.userRoleFuncList));
								saveMenus(res.data.userRoleFuncList ? res.data.userRoleFuncList : []);
								saveSySMenus(res.data.userRoleFuncList ? res.data.userRoleFuncList : []);
								addUserOrgs(orgUsertree(res.data.userOrgsInfoList) || []);
								addUserInfo(res.data.userInfo || {});
								localStorage.setItem('myWorkplat', JSON.stringify(res.data.userWorkbenchList));
								// addMenusHistory(
								// 	res.data.userWorkbenchList.includes('1276005')
								// 		? [
								// 				{
								// 					path: '/zeus-system/system-permissions/workingPlatform',
								// 					name: '我的工作台',
								// 					parentId: '523523270839386118'
								// 				}
								// 		  ]
								// 		: []
								// );
								// window.location.reload();
							}
							history.push('/');
						});
					} else {
						// 如果是第一次登录，wechatOpenId则需要绑定手机号
						setShowBindPage(true);
						setWeChatOpenId(data.data.weChatOpenId);
					}
				} else {
					// message.error(data.msg || '账号异常，请稍后重试');
					backLoginPage();
				}
			});
		}
	}, [weChatOpenId]); // eslint-disable-line react-hooks/exhaustive-deps
	return (
		<div className="wxLogin">
			<div className={`login-wrap ${bgImg[orgTypeCode]}`}>
				<div className="login-left">
					<div className="login">
						<TBIcon type="tb-logo-y" />
						<p>蜂巢灵工</p>
						<span className="segmentation"></span>
						<span>{TypeName[orgTypeCode]}</span>
					</div>
					<div className="login-title">
						<h1>企业用工数字化平台</h1>
						<p>服务、创新、科技、未来</p>
					</div>
				</div>
				{showBindPage && (
					<div className="login-right">
						<div className="wxLoginRight">
							<CloseOutlined className="backIcon" onClick={backLoginPage} />
							<p className="login-right-title">绑定手机号</p>
							<p className="bindPhoneTip">
								首次使用微信扫码登录服务需要验证手机号，如您已验证通过，扫码授权成功后将自动登录系统。
							</p>
							<div>
								<div className="login-right-tel">
									<p>+86 |</p>
									<Input placeholder="请输入手机号" value={phone} onChange={changePhone} />
								</div>

								<ReactSimpleVerify
									disabled
									ref={couterRef}
									successTips={successTips}
									successIcon={successIcon}
									width={300}
									height={40}
									movedColor={'#FC6732'}
									success={success}
								/>
								{showCodeBtn && (
									<div className="login-right-Code">
										<Input placeholder="请输入验证码" value={code} onChange={changeCode} />
										<Button type="primary" onClick={getCode}>
											{codeTip}
										</Button>
									</div>
								)}
								<div className="fileTip">
									<Tooltip
										placement="bottomLeft"
										title={!codeCheckbox ? '请先阅读并同意协议' : ''}
										arrowPointAtCenter
										visible={!codeCheckbox}>
										<Checkbox onChange={changeCodeCheckbox} defaultChecked={true}></Checkbox>
									</Tooltip>
									<span>阅读并同意</span>
									<span onClick={openAgreement}>《用户服务协议》</span>
								</div>
								<div style={{ marginTop: '20px' }}>
									<Button className={code ? 'loginButton' : 'loginButtonDisabled'} type="primary" onClick={gotoLogin}>
										登录
									</Button>
								</div>
							</div>
						</div>
						<Modal
							closable
							key={updateKey}
							maskClosable={false}
							title="用户服务协议"
							visible={isModalOpen}
							width="50%"
							footer={
								<Button type="primary" onClick={handleModalOk}>
									同意
								</Button>
							}
							onOk={handleModalOk}
							onCancel={handleModalCancel}>
							<UserAgreement></UserAgreement>
						</Modal>
						<span className="copyRight">版权所有 © 2021 福建桐邦信息科技有限公司 | 闽ICP备2021001372号-2</span>
					</div>
				)}
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	return {
		menusHistory: state.menusHistory
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		saveLoginInfo: (info) => dispatch({ type: 'ADD_LOGININFO', info }),
		saveMenus: (info) => dispatch({ type: 'ADD_MENUS', info }),
		addUserOrgs: (info) => dispatch({ type: 'ADD_USERORGS', info }),
		addUserInfo: (info) => dispatch({ type: 'ADD_USERINFO', info }),
		addMenusHistory: (info) => dispatch({ type: 'ADD_MENUSHISTORY', info }),
		saveSySMenus: (info) => dispatch({ type: 'ADD_SYSMENUS', info }),
		addHeaderParentIds: (info) => dispatch({ type: 'ADD_HEADERPARENTID', info })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(WxLogin);
